// Bar order is `sort`; an action's `order` (registry.ts) picks its family's icon and places the rest in ⋮.
import type { CatalogKey } from "@/actions/catalog";

export interface Family {
  sort: number;
  label: string;
  icon: CatalogKey;
}

const SPECS = {
  // Commit mode's own section, ✕ before ↑; `COMMIT_SCOPE` keeps it out of the fold.
  discard: { sort: 1, label: "Discard", icon: "discardEdits" },
  commit: { sort: 2, label: "Commit", icon: "commit" },
  view: { sort: 5, label: "View", icon: "viewFile" },
  version: { sort: 10, label: "Checkpoints", icon: "version" },
  filter: { sort: 15, label: "Filter", icon: "addFilter" },
  add: { sort: 20, label: "Add", icon: "newTable" },
  import: { sort: 25, label: "Import", icon: "importTable" },
  type: { sort: 30, label: "Type", icon: "displayNumber" },
  describe: { sort: 40, label: "Describe", icon: "addDescription" },
  transform: { sort: 50, label: "Transform", icon: "splitColumn" },
  connect: { sort: 60, label: "Connect", icon: "linkColumn" },
  export: { sort: 70, label: "Export", icon: "export" },
  share: { sort: 80, label: "Share", icon: "manageAccess" },
  addColumn: { sort: 85, label: "Add column", icon: "addColumnRight" },
  arrange: { sort: 86, label: "Arrange", icon: "arrange" },
  alignX: { sort: 87, label: "Align horizontally", icon: "alignLeft" },
  alignY: { sort: 88, label: "Align vertically", icon: "alignTop" },
  distribute: { sort: 89, label: "Distribute", icon: "distributeHorizontally" },
  more: { sort: 900, label: "More", icon: "more" },
} satisfies Record<string, Family>;

export type FamilyId = keyof typeof SPECS;

export const FAMILIES: Readonly<Record<FamilyId, Family>> = SPECS;
